// @ts-nocheck

import React, { Fragment } from 'react';
import styled from 'styled-components';

import { __ } from '../../i18n/l10n';

const ThinWeight = styled.span`
  font-weight: normal;
`;

type MyMatchMultichoiceLabelProps = {
  labels: Array<string>;
};

const MyMatchMultichoiceLabel = ({ labels }: MyMatchMultichoiceLabelProps) => (
  <div>
    {labels.map((label, index) => (
      <Fragment key={label}>
        {index !== 0 && <ThinWeight> {__('or')} </ThinWeight>}
        {label}
      </Fragment>
    ))}
  </div>
);

export default MyMatchMultichoiceLabel;
